import { AudioUnitType } from "@opendaw/studio-enums";
export const AudioUnitOrdering = {
    [AudioUnitType.Instrument]: 0,
    [AudioUnitType.Aux]: 1,
    [AudioUnitType.Bus]: 2,
    [AudioUnitType.Output]: 3
};
